import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    cancelOrder({
        commit
    }, {
        orderId,
        cancelData
    }) {
        // orderId, note, refundValue
        return request.post(`admin/prepaid/order/${orderId}/cancel`, cancelData)
    },
    storeOrder({
        commit
    }, storeData) {
        return request.post('/admin/prepaid/order/store', storeData)
    },
    fetchOrderSingle({
        commit
    }, orderId) {
        return request
            .get(`/admin/prepaid/order/${orderId}`)
            .then((response) => response.items)
    },
    fetchOrders({
        commit
    }, query) {
        return request.post('/admin/prepaid/order/search', query)
    },
    updateState({
        commit
    }, {
        ids,
        state
    } = {}) {
        return request.post('/admin/prepaid/state', {
            ids,
            state
        })
    },
    remove({
        commit
    }, {
        ids
    }) {
        return request.post('/admin/prepaid/remove', {
            ids
        })
    },

    store({
        commit
    }, storeData) {
        return request.post('/admin/prepaid/store', storeData)
    },
    fetchSingle({
        commit
    }, prepaidId) {
        return request
            .get(`/admin/prepaid/${prepaidId}`)
            .then((response) => response.items)
    },
    fetchList({
        commit
    }, query) {
        return request
            .post('/admin/prepaid/search', query)
            .then(({
                items,
                pagination: {
                    total
                }
            }) => {
                return {
                    items,
                    total,
                }
            })
    },
    sendLink({
        commit
    }, {
        orderId,
        router
    }) {
        return request.post(`admin/prepaid/order/${orderId}/sendLink`, {
            router
        })
    },
}
